import { z } from "zod";

export const appointmentSchema = z.object({
  appointmentDate: z.string().min(1, "Appointment date is required"),
  notes: z.string().optional(),
});

export const quotationSchema = z.object({
  VerveCapacity: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.string().min(1, "Capacity is required"), z.number()])),
  quotationAmount: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.string().min(1, "Amount is required"), z.number()])),
  notes: z.string().optional(),
});

export const subsidySchema = z.object({
  hasSubsidy: z.enum(["yes", "no"], { required_error: "Please select subsidy status" }),
  subsidyId: z.string().optional(),
  notes: z.string().optional(),
}).refine(data => data.hasSubsidy === 'no' || !!data.subsidyId, {
  message: "Subsidy ID is required",
  path: ["subsidyId"],
});

export const assignmentSchema = z.object({
  assignedTo: z.string().min(1, "Please select a Sales Executive"),
  notes: z.string().optional(),
});
